import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { Layout } from "antd";
import SideBar from "./sideBar";

import ProtectedRoute from "./ProtectedRoute";
import LayoutHeader from "./layoutHeader";
import Employee from "../admin/employee/employee";
import Designer from "../admin/employee/designer/designer";
import Developer from "../admin/employee/developer/developer";
import Accountant from "../admin/employee/accountant/accountant";
import Dashboard from "../admin/dashboard/dashboard";
import Freelancer from "../admin/employee/freelancer/freelancer";
import Telecaller from "../admin/employee/telecaller/telecaller";
import Viewuser from "../admin/employee/viewuser";
import Receptionist from "../admin/employee/receptionist/receptionist";
import Projectindex from "../admin/project";
import ClientIndex from "../admin/client";
import ViewClient from "../admin/client/viewclient";
import ViewProject from "../admin/project/viewProject";

import VisitorsDetails from "../admin/receptionist/visitorsDetails/visitorsDetails";
import TelecallerIndex from "../admin/receptionist/telecallerDetails/telecallerIndex";
import UpdateVisitors from "../admin/receptionist/visitorsDetails/updateVisitors";
import InvoiceGenerator from "../admin/invoice/invoice";
import LeaveDetailsAdmin from "../admin/leaveDetails/leaveDetails";
import LeaveupdateDetails from "../admin/leaveDetails/leaveupdateDetails";
import PayrollIndex from "../admin/payrollDetails/payrollIndex";
import SalaryPaymentDetails from "../admin/payrollDetails/salaryPaymentDetails";
import ClientPaymentDetails from "../admin/payrollDetails/clientPaymentDetails";
import UpdatePayrollDetails from "../admin/payrollDetails/updatePayrollDetails";
import ViewTaskData from "../admin/task/viewTaskData";
import Monthlyplanner from "../admin/monthlyPlanner/monthlyplanner";
import MonthlyReport from "../admin/monthlyReport/monthlyReport";
import IndexMonthlyplanner from "../admin/monthlyPlanner/indexMonthlyplanner";
import UpdateMonthlyPlanner from "../admin/monthlyPlanner/updateMonthlyPlanner";
import MonthlyReportIndex from "../admin/monthlyReport/monthlyReportIndex";
import UpdateMonthlyReport from "../admin/monthlyReport/updateMonthlyReport";
import InvoiceIndex from "../admin/invoice/invoiceIndex";
import Invoice from "../admin/invoice/invoice";
import UpdateInvoice from "../admin/invoice/updateInvoice";
import InternshipIndex from "../admin/internship/internshipIndex";
import UpdateInternship from "../admin/internship/updateInternship";
import InternshipPayement from "../admin/internship/internshipPayement";
import TotalPaymentDetails from "../admin/payrollDetails/totalPaymentDetails";

const Navigation = () => {
  const user = useSelector((state: any) => state.user);
  const [collapsed, setCollapsed] = useState(false);
  const { Sider, Content } = Layout;

  return (
    <Layout>
      <Sider
        style={{ backgroundColor: "#FF1A1A", height: "100vh" }}
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={collapsed ? 40 : 250}
      >
        <SideBar
          collapsed={collapsed}
          doCollapse={() => setCollapsed(!collapsed)}
        />
      </Sider>
      <Layout>
        <LayoutHeader />
        <Content style={{ background: "#fff" }}>
          <Routes>
            {/* Redirect root (/) to /login if the user is not authenticated */}
            <Route path="/" element={<Dashboard />} />

            <Route
              path="/Dashboard"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Dashboard />
                </ProtectedRoute>
              }
            />

            {/* <Route path="/*" element={<Login />} /> */}

            <Route
              path="/Employee"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Employee />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Developer"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Developer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Accountant"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Accountant />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Designer"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Designer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Freelancer"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Freelancer />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Telecaller"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Telecaller />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Employee/viewuser/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Viewuser />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Client/viewclient/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <ViewClient />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Project/projectview/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <ViewProject />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Receptionist"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Receptionist />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Project"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Projectindex />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Client"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <ClientIndex />
                </ProtectedRoute>
              }
            />

            <Route
              path="/task_view/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <ViewTaskData />
                </ProtectedRoute>
              }
            />

            <Route
              path="/VisitorsDetails"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <VisitorsDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/VisitorsDetails/update/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <UpdateVisitors />
                </ProtectedRoute>
              }
            />
            <Route
              path="/TelecallerDetails"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <TelecallerIndex />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Invoice"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <InvoiceIndex />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Invoice/createinvoice"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Invoice />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Invoice/viewinvoice/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <UpdateInvoice />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Leave"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <LeaveDetailsAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/leave-update/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <LeaveupdateDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/payroll_Details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <PayrollIndex />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Salary_Details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <SalaryPaymentDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Client_Payment_Details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <ClientPaymentDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Total_Payment_Details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <TotalPaymentDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/updatePayroll/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <UpdatePayrollDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Monthlyplanner"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <IndexMonthlyplanner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Monthlyplanner/planner/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Monthlyplanner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Monthlyplanner/planner/Edit/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <UpdateMonthlyPlanner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/MonthlyReport"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <MonthlyReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/MonthlyReport/Report/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <MonthlyReportIndex />
                </ProtectedRoute>
              }
            />
            <Route
              path="/MonthlyReport/Report/Edit/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <UpdateMonthlyReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/InternshipIndex"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <InternshipIndex />
                </ProtectedRoute>
              }
            />
            <Route
              path="/InternshipIndex/updateInternship/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <UpdateInternship />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Internship_Payment_Details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <InternshipPayement />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default Navigation;
